export default "__VITE_ASSET__08dd6a5f__"